var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalleryNext({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -32,
    y: -32,
    width: 104,
    height: 104
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(16px)",
      clipPath: "url(#bgblur_0_1232_8486_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 32
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1232_8486",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40V38C10.0589 38 2 29.9411 2 20H0H-2C-2 32.1503 7.84974 42 20 42V40ZM40 20H38C38 29.9411 29.9411 38 20 38V40V42C32.1503 42 42 32.1503 42 20H40ZM20 0V2C29.9411 2 38 10.0589 38 20H40H42C42 7.84974 32.1503 -2 20 -2V0ZM20 0V-2C7.84974 -2 -2 7.84974 -2 20H0H2C2 10.0589 10.0589 2 20 2V0Z",
    fill: "black",
    mask: "url(#path-1-inside-1_1232_8486)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1232_8486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3976 29.7427C15.0795 29.4101 15.0912 28.8826 15.4238 28.5645L24.3776 20L15.4238 11.4355C15.0912 11.1174 15.0795 10.5899 15.3976 10.2573C15.7158 9.92473 16.2433 9.91301 16.5759 10.2311L26.1592 19.3978C26.3235 19.555 26.4165 19.7726 26.4165 20C26.4165 20.2274 26.3235 20.445 26.1592 20.6022L16.5759 29.7689C16.2433 30.087 15.7158 30.0753 15.3976 29.7427Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1232_8486_clip_path",
    transform: "translate(32 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1232_8486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryNext);
export default __webpack_public_path__ + "static/media/gallery-next.fc81a614fb96cb25ad0cb98e0e8d7243.svg";
export { ForwardRef as ReactComponent };